import { createContext } from "react";

export const Context = createContext<{
  worker?: Worker;
  nodeEnv?: string;
  env?: string;
}>({});
